__turbopack_context__.v({
  "field": "FieldGroup-module__WNiz7G__field",
  "fieldGroup": "FieldGroup-module__WNiz7G__fieldGroup",
  "universalField": "FieldGroup-module__WNiz7G__universalField",
  "universalFieldGroup": "FieldGroup-module__WNiz7G__universalFieldGroup",
});
